<template>
  <div id="app">
    <router-view name="header" />
    <router-view name="menu" />
    <router-view id="main-content" class="container-fluid" />
    <router-view name="footer" />
    <div v-show="loading" class="loading">
      <img :src="images.loading" alt />
    </div>
    <message-notifier
      v-show="showMessage"
      @close="showMessage = false"
      :message="msg"
      :title="msgTitle"
    />
  </div>
</template>
<script>
import images from "./core/images";
import translateData from "./assets/data/en-US.json";
import MessageNotifier from "./views/MessageNotifier";
import { mapState, mapMutations, mapGetters } from "vuex";
import { getFinancialYears } from "./core/staff-helper";
export default {
  components: {
    MessageNotifier: MessageNotifier,
  },
  data() {
    return {
      msg: null,
      msgTitle: null,
      showMessage: false,
      checkTokenInterval: null,
      events: ["mousedown", "touchstart", "mousemove", "scroll"],
    };
  },
  created() {
    this.setCountries(translateData.countries);
    this.setOD(translateData.origindestination);
    const force = this.staffId === "9999999";
    this.setFinancialYears(getFinancialYears(force));
    this.$api.getTranslationData().then((r) => {
      this.setCountries(r.data.countries);
      this.setOD(r.data.origindestination);
    });
  },
  watch: {
    messagePopup: {
      deep: true,
      handler: function(val) {
        if (val) {
          this.msg = val.message;
          this.msgTitle = val.title;
          this.showMessage = true;
        } else {
          this.msg = "";
          this.msgTitle = "";
          this.showMessage = false;
        }
      },
    },
  },
  computed: {
    images: () => images,
    ...mapGetters(["loading","staffId"]),
    ...mapState(["OD", "token", "countries", "messagePopup"]),
  },
  methods: {
    checkAndRedirect() {
      if (this.$router.currentRoute.path !== "/login") {
        this.$sso.checkStatus(this.token).catch(() => {
          this.setToken("");
          this.$router.push("/login");
        });
      }
    },
    resetCheckInterval() {
      if (this.checkTokenInterval) {
        clearInterval(this.checkTokenInterval);
      }
      return this.setCheckInterval();
    },
    setCheckInterval() {
      const checkTime = 5 * 60 * 1000;
      this.checkTokenInterval = setInterval(
        () => this.checkAndRedirect(),
        checkTime
      );
    },
    ...mapMutations([
      "setOD",
      "setToken",
      "setCountries",
      "setMessagePopup",
      "setFinancialYears",
    ]),
  },
  mounted() {
    this.setCheckInterval();
    this.events.forEach((x) =>
      document.addEventListener(x, this.resetCheckInterval)
    );
  },
  destroyed() {
    this.events.forEach((x) =>
      document.removeEventListener(x, this.resetCheckInterval)
    );
    if (this.checkTokenInterval) {
      clearInterval(this.checkTokenInterval);
      this.checkTokenInterval = null;
    }
  },
};
</script>
<style lang="scss">
@import "./assets/styles/bootstrap.css";
@import "./assets/styles/global.scss";
#app {
  overflow-x: hidden;
  .loading {
    position: absolute;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 99999;
    user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    background: rgba(255, 255, 255, 0.5);
    img {
      position: absolute;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 15rem;
      pointer-events: none;
    }
  }
}
</style>
